/**
 * Reja oynasi (BudgetLayout PlanModal) uchun sof hisob-kitob (test: plans.test.ts).
 * Qaysi filiallar saqlanadi: biror maydoni yozilgan yoki serverda rejasi bor (bo'sh maydon = 0 -- tozalab 0 qilish
 * saqlanadi, 2026-10-18 xatosi: avval hamma maydoni bo'sh filial o'tkazib yuborilar va eski reja qolardi).
 * Rejasi yo'q va hech narsa yozilmagan filial uchun bo'sh reja yaratilmaydi.
 */
import type { BudgetBranch, BudgetPlan, PlanUpsertItem } from "./types";
import { money } from "./types";

export type PlanRow = { expenses: string; salaries: string; bonuses: string };

export const EMPTY_ROW: PlanRow = { expenses: "", salaries: "", bonuses: "" };

/** Serverdagi rejalardan oynaning boshlang'ich qatorlari */
export function planRows(branches: Pick<BudgetBranch, "id">[], plans: BudgetPlan[]): Record<number, PlanRow> {
  const rows: Record<number, PlanRow> = {};
  for (const b of branches) {
    const p = plans.find((x) => x.branch === b.id);
    rows[b.id] = p ? { expenses: String(money(p.planned_expenses)), salaries: String(money(p.planned_salaries)), bonuses: String(money(p.planned_bonuses)) } : { ...EMPTY_ROW };
  }
  return rows;
}

/** Saqlash so'rovi: bo'sh maydon "0"; rejasi bo'lmagan va to'liq bo'sh filial tushib qoladi */
export function planUpsertItems(
  branches: Pick<BudgetBranch, "id">[],
  rows: Record<number, PlanRow | undefined>,
  plans: BudgetPlan[],
  year: number,
  month: number,
): PlanUpsertItem[] {
  const items: PlanUpsertItem[] = [];
  for (const b of branches) {
    const row = rows[b.id];
    const existing = plans.find((x) => x.branch === b.id);
    if (!row) continue;
    const typed = row.expenses !== "" || row.salaries !== "" || row.bonuses !== "";
    if (!typed && !existing) continue;
    items.push({
      branch: b.id,
      year,
      month,
      planned_expenses: row.expenses || "0",
      planned_salaries: row.salaries || "0",
      planned_bonuses: row.bonuses || "0",
      version: existing?.version ?? null,
    });
  }
  return items;
}
